import reject from 'lodash/reject';
import isEmpty from 'lodash/isEmpty';

function parse(keywordsInUrl) {
  if (keywordsInUrl) {
    const decodedKeywords = decodeURIComponent(keywordsInUrl);
    const commaSeparatedKeywords = reject(decodedKeywords.replace(/\+/g, ' ').split(' '), isEmpty).join(', ');
    return commaSeparatedKeywords;
  }
}

export default { parse };
